/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { When } from 'react-if'
import { LinkButton } from '@/atoms/Button'
import { CartIcon } from '@/atoms/Icons/CartIcon'
import { CaptionSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { OwnershipAvatars } from '@/organisms/CollectibleSceneInfo/CollectibleSceneDetails/CollectibleSceneOwnership/OwnershipAvatars'
import { useCollectiblesPlayer } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerContext'
import { MomentOwner, MomentOwnerStory } from '@/services/MomentsService/types'
import { createPlaceholderArray } from '@/utils/PlaceholderArrays'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { MomentOwnershipAvatar } from './MomentOwnershipAvatar'
import { OwnersRemainingCaption } from './OwnersRemainingCaption'
import { UserOwnershipSection } from './UserOwnershipSection'

const PLACEHOLDERS = createPlaceholderArray(10)

interface CollectibleSceneOwnershipProps {
  actors: MomentOwner[]
  isOwner?: boolean
  loading: boolean
  myStory?: MomentOwnerStory
  owners: MomentOwner[]
  totalNumberOfOwners: number
  projectName?: string
  momentId?: string | null
  availableFrames?: number | null
}

export const CollectibleSceneOwnership: React.FC<CollectibleSceneOwnershipProps> = ({
  owners,
  isOwner,
  myStory,
  loading,
  actors,
  totalNumberOfOwners,
  projectName,
  availableFrames,
}) => {
  const { t } = useTranslate('watch')
  const { getCurrentMoment } = useCollectiblesPlayer()

  const currentMoment = getCurrentMoment()

  if (!totalNumberOfOwners) return null

  const canPurchase = Boolean(currentMoment?.defaultOffer)

  return (
    <div className="relative mb-6 w-full rounded-xl bg-gray-800 p-4">
      <CaptionSM color="gray-500" className="mb-2">
        <Translate i18nKey="sceneOwners" t={t}>
          Scene owners
        </Translate>
      </CaptionSM>

      <div className="my-3 flex items-center">
        {loading &&
          PLACEHOLDERS.map((v, index) => (
            <MomentOwnershipAvatar key={v} className="bg-gray-600" index={index} iconPosition="none" />
          ))}
        <When condition={!loading && owners?.length}>
          <OwnershipAvatars projectName={projectName} actors={actors} owners={owners} />
        </When>
        <OwnersRemainingCaption totalNumberOfOwners={totalNumberOfOwners} />
      </div>
      <When condition={isOwner}>
        <UserOwnershipSection projectName={projectName} myStory={myStory} />
      </When>
      <When condition={canPurchase}>
        {/* <LinkButton variant="gray-900" href={`${paths.collectibles.shop(projectName)}`} className="w-fit">
          <CartIcon className="mr-2" />
          Buy This Scene
        </LinkButton>
        <CaptionSM color="gray-500" className="mt-2">
          {availableFrames} frames available
        </CaptionSM> */}
      </When>
    </div>
  )
}
